<template>
  <div>
    <h3>交流项目</h3>
    <b-card>
      <b-card-body>
        <b-list-group>
          <b-list-group-item
            v-for="(item, index) in programs"
            v-bind:key="index"
            class="d-flex justify-content-between align-items-center"
          >
            <router-link
              :to="'/collaboration/detail?type=program&id=' + item.id"
            >
              {{ item.title }}
            </router-link>
            <b-badge variant="light" pill>{{ item.date }}</b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-card>
    <div class="overflow-auto">
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-text="首页"
          prev-text="上一页"
          next-text="下一页"
          last-text="尾页"
          align="center"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      programs: [],
      rows: 0,
      currentPage: 1,
      perPage: 10,
    };
  },
  created: function () {
    this.get_program_list();
  },
  watch: {
    currentPage: function (val) {
      let url =
        "collaboration/programs/?ordering=-add_time&p=" +
        val +
        "&page_size=" +
        this.perPage;
      this.$http.get(url).then((response) => {
        this.programs = response.data.results;
      });
    },
  },
  methods: {
    get_program_list: function () {
      let url =
        "collaboration/programs/?ordering=-add_time&p=" +
        this.currentPage +
        "&page_size=" +
        this.perPage;
      this.$http.get(url).then((response) => {
        this.programs = response.data.results;
        this.rows = response.data.count;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  background-color: #f5f6fa;
  border: none;
  margin: 0 0 20px 0;
  padding: 5px 0;
  hr {
    border-bottom: 1px dashed #e9ecef;
  }
  .card-body {
    margin: 0;
    padding: 0 10px 0 0;
  }
  a {
    color: #3e3e3e !important;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: block;
  }
  .list-group-item {
    background-color: #f5f6fa;
    border-top: none;
    border-left: none;
    border-right: none;
    margin-top: 10px;
  }
  .badge {
    margin-left: 20px;
    font-weight: normal;
    color: #9e9e9e;
    font-size: 14px;
  }
}
</style>
